var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{attrs:{"span":_vm.span}},[_c('el-form-item',{attrs:{"label":_vm.label}},[_c('el-input',{attrs:{"size":"small","disabled":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }